import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: #090719;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    height: 100dvh;
    padding: 30px;
    padding-right: 20px;

    display: flex;
    gap: 40px;

    position: relative;
    z-index: 1;

    @media (max-width: 1000px) {
        flex-direction: column;
        gap: 20px;
        justify-content: flex-end;
        align-items: center;
        padding: 20px;
    }
`;

export const Logo = styled.div`
    position: absolute;
    top: 40px;
    left: 40px;
    z-index: 3;

    svg {
        width: 88px;
    }

    @media (max-width: 1000px) {
        top: 30px;
        left: 20px;
    }
`;
